import { render, staticRenderFns } from "./CordinacionGeneralSimplificacion.vue?vue&type=template&id=e9dc6ea8&"
import script from "./CordinacionGeneralSimplificacion.vue?vue&type=script&lang=js&"
export * from "./CordinacionGeneralSimplificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports